module.exports = __webpack_public_path__ + "images/website3-849f088e531aa527fde66764bbd967bb.jpg";